module.exports = __webpack_public_path__ + "static/media/py.9b51074b.svg";